import {ResolveFn} from '@angular/router';
import {Dataset} from '../api/fit-api/models/datasets/dataset';
import {inject} from '@angular/core';
import {DatasetService} from '../api/fit-api/dataset.service';
import {DatasetType} from '../api/fit-api/models/datasets/dataset-type';
import {combineLatest} from "rxjs";
import {map} from "rxjs/operators";

export const adminDatasetsResolver: ResolveFn<{
	snapshot: Dataset,
	schools: Dataset,
	live: Dataset
}> = (route, state) => {
	const datasetService = inject(DatasetService);
	let snapshotFromRoute = undefined;

	// 1a. If datasetType (+ datasetId) provided, resolve that Dataset
	const datasetType = route.paramMap.get('snapshotDatasetType') as DatasetType;
	if (datasetType) {
		const datasetId = route.paramMap.get('snapshotDatasetId') ? Number(route.paramMap.get('snapshotDatasetId')) : undefined;
		snapshotFromRoute = datasetService.getDataset(datasetType, datasetId);
	}

	// 1b. Otherwise, get the default Dataset for this route...
	const defaultSnapshotDatasetType = DatasetType.Snapshot;

	// 2. Set Live and Schools datasets
	const liveDatasetType = DatasetType.Live;
	const schoolsDatasetType = DatasetType.Schools;

	return combineLatest([
		snapshotFromRoute ?? datasetService.getDataset(defaultSnapshotDatasetType),
		datasetService.getDataset(schoolsDatasetType),
		datasetService.getDataset(liveDatasetType)])
		.pipe(map(([snapshot, schools, live]) => {
			return {
				snapshot: snapshot,
				schools: schools,
				live: live
			}
		}));
};
